import { useSectionEventOnViewportEntrance } from '@/hooks/useSectionEventOnViewportEntrance';
import React, { useContext } from 'react';
import { type Coverage, CoverageSection } from './Coverage';
import { CarPageContext } from './CarPageContext';

export interface ElectricCoveragesProps {
  title: string;
  subtitle: string;
  data: Coverage[];
}

const ElectricCoverages: React.FC<ElectricCoveragesProps> = ({ title, subtitle, data }) => {
  const { analytics } = useContext(CarPageContext);
  const intersectionRef = useSectionEventOnViewportEntrance({
    sectionName: 'electricCoverages',
    page: analytics?.page,
    position: 6,
  });

  return <CoverageSection title={title} subtitle={subtitle} coverages={data} ref={intersectionRef} />;
};

export default React.memo(ElectricCoverages);
